import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './styles.css';

export default function ChangePasswordPage() {
  const { api, updateUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ current: '', new: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new !== form.confirm) return toast.error('Les mots de passe ne correspondent pas');
    if (form.new.length < 8) return toast.error('Minimum 8 caractères');
    setLoading(true);
    try {
      await api.put('/auth/change-password', { current_password: form.current, new_password: form.new });
      updateUser({ must_change_password: false });
      toast.success('Mot de passe modifié !');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#3C2618', padding: '1rem' }}>
      <div style={{ background: 'white', borderRadius: 24, padding: '2.5rem', width: '100%', maxWidth: 400 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '2rem' }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: '#95C11F', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 16, color: 'white' }}>MB</div>
          <div>
            <div style={{ fontSize: 17, fontWeight: 700 }}><span style={{color:'#1c1c1e'}}>Matin</span><span style={{color:'#95C11F'}}> Business</span></div>
          </div>
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1c1c1e', marginBottom: 6 }}>Changer votre mot de passe</h1>
        <p style={{ fontSize: 14, color: '#8e8e93', marginBottom: 24 }}>Première connexion — choisissez un nouveau mot de passe sécurisé.</p>
        <form onSubmit={handleSubmit}>
          {[
            { label: 'Mot de passe actuel', key: 'current' },
            { label: 'Nouveau mot de passe', key: 'new' },
            { label: 'Confirmer le nouveau', key: 'confirm' },
          ].map(f => (
            <div key={f.key} className="mb-field">
              <label className="mb-label">{f.label}</label>
              <input type="password" required value={form[f.key]} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} className="mb-input" />
            </div>
          ))}
          <button type="submit" disabled={loading} className="mb-btn mb-btn-primary mb-w-full" style={{ padding: 13, fontSize: 15, justifyContent: 'center', borderRadius: 12, marginTop: 8 }}>
            {loading ? 'Enregistrement...' : 'Enregistrer mon mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
}
